"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { Spinner } from "@/shared/ui/atoms";
import { Loading } from "@/shared/ui/organisms";
import { RankingHospitalItem } from "@/widgets/search-ranking/model/types";
import { RankingHospitalCard } from "@/widgets/search-ranking/ui/molecules";
interface RankingHospitalListProps {
  items: RankingHospitalItem[];
  onAnchorCapture?: (hospitalOriginId: number, el: HTMLElement | null) => void;
  /** 각 병원의 상세 경로. 없으면 카드가 기존 상세 경로를 쓴다. */
  resolveHref?: (item: RankingHospitalItem) => string;
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  isLoading: boolean;
}
const RankingHospitalList = t0 => {
  const $ = _c(25);
  const {
    items,
    onAnchorCapture,
    resolveHref,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading
  } = t0;
  const loadMoreRef = useRef(null);
  const hasUserScrolledRef = useRef(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const onScroll = () => {
        if (window.scrollY > 0) {
          hasUserScrolledRef.current = true;
        }
      };
      window.addEventListener("scroll", onScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", onScroll);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== fetchNextPage || $[3] !== hasNextPage || $[4] !== isFetchingNextPage) {
    t3 = () => {
      if (!loadMoreRef.current || !hasNextPage || isFetchingNextPage) {
        return;
      }
      const observer = new IntersectionObserver(t4 => {
        const [entry] = t4;
        if (entry.isIntersecting && hasUserScrolledRef.current) {
          fetchNextPage();
        }
      }, {
        rootMargin: "200px"
      });
      observer.observe(loadMoreRef.current);
      return () => observer.disconnect();
    };
    $[2] = fetchNextPage;
    $[3] = hasNextPage;
    $[4] = isFetchingNextPage;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== fetchNextPage || $[7] !== hasNextPage || $[8] !== isFetchingNextPage || $[9] !== items.length) {
    t4 = [fetchNextPage, hasNextPage, isFetchingNextPage, items.length];
    $[6] = fetchNextPage;
    $[7] = hasNextPage;
    $[8] = isFetchingNextPage;
    $[9] = items.length;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  useEffect(t3, t4);
  if (isLoading) {
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Loading />;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  let t5;
  if ($[12] !== items || $[13] !== onAnchorCapture || $[14] !== resolveHref) {
    let t6;
    if ($[16] !== onAnchorCapture || $[17] !== resolveHref) {
      t6 = item => <RankingHospitalCard key={item.hospitalOriginId} item={item} onAnchorCapture={onAnchorCapture} href={resolveHref?.(item)} />;
      $[16] = onAnchorCapture;
      $[17] = resolveHref;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    t5 = items.map(t6);
    $[12] = items;
    $[13] = onAnchorCapture;
    $[14] = resolveHref;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div ref={loadMoreRef} className="h-1" aria-hidden={true} />;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== isFetchingNextPage) {
    t7 = isFetchingNextPage ? <div className="flex items-center justify-center py-3"><Spinner size={42} /></div> : null;
    $[20] = isFetchingNextPage;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t5 || $[23] !== t7) {
    t8 = <div className="flex w-full flex-col gap-2">{t5}{t6}{t7}</div>;
    $[22] = t5;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
};
export default RankingHospitalList;